import { IconContentLink } from '@doltech/icons/IconContentLink';
import * as React from 'react';
import { Editor } from 'slate';
import { useSlate } from 'slate-react';

import { ToolbarButtonProps } from '../../../../../slatePlugins/components/ToolbarButton/ToolbarButton.types';
import { ToolbarElement } from '../../../../../slatePlugins/components/ToolbarElement';
import { DEFAULT_BG_COLORS, MARK_BG_COLOR } from '../../../marks/background-color/defaults';
import { withDisableToolbarItem } from '../../../toolbars/disable-item/withDisableToolbarItem';
import { usePreventHiddenToolbar } from '../../../toolbars/prevent-toolbar-hidden/PreventToolbarHiddenContext';
import { HyperLinkPopoverOnExpanded } from '../components/HyperLinkPopoverOnExpanded';
import { ELEMENT_HYPER_LINK } from '../defaults';

interface ToolbarHyperLinkProps extends ToolbarButtonProps {}

export const ToolbarHyperLinkBase = (props: ToolbarHyperLinkProps) => {
  const editor = useSlate();
  const { setPreventToolbarHidden } = usePreventHiddenToolbar();

  const handlePopoverClose = React.useCallback(() => {
    setPreventToolbarHidden(false);

    // Remove fake selection
    Editor.removeMark(editor, MARK_BG_COLOR);
  }, [editor, setPreventToolbarHidden]);

  const handlePopoverFocus = React.useCallback(() => {
    setPreventToolbarHidden(true);

    // Add fake selection when Editor lose focus and focus popover hyperlink form
    Editor.addMark(editor, MARK_BG_COLOR, { colorKey: DEFAULT_BG_COLORS.primary10 });
  }, [editor, setPreventToolbarHidden]);

  return (
    <HyperLinkPopoverOnExpanded
      onApplyLink={handlePopoverClose}
      onPopoverClose={handlePopoverClose}
      onPopoverFocus={handlePopoverFocus}
    >
      <ToolbarElement type={ELEMENT_HYPER_LINK} icon={<IconContentLink />} {...props} />
    </HyperLinkPopoverOnExpanded>
  );
};

export const ToolbarHyperLink = withDisableToolbarItem(ToolbarHyperLinkBase);
